import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DocumentKeys } from "web_myplann/Api/Document/DocumentKeys";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { patchDocumentIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type Variables = {
	documentId: number;
	link: { portfolioId: number } | { propertyId: number };
};

export const usePinDocumentMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse(({ documentId, link }: Variables) =>
			patchDocumentIdV2(link, documentId),
		),
		onSettled: () => {
			queryClient.invalidateQueries({ queryKey: DocumentKeys.allLists });
			queryClient.invalidateQueries({ queryKey: PortfolioKeys.all });
		},
	});
};
